import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  TutorialVideoSummary,
  TutorialVideoUpdatePayload,
  TutorialVideoUploadPayload,
} from 'brain-data/model/tutorial-video.model';

export const loadTutorialVideos = createAction('[TutorialVideos] load');
export const loadTutorialVideosSuccess = createAction(
  '[TutorialVideos] load success',
  props<{ videos: TutorialVideoSummary[] }>(),
);
export const loadTutorialVideosError = createAction(
  '[TutorialVideos] load error',
  props<{ error: HttpErrorResponse }>(),
);

export const uploadTutorialVideo = createAction(
  '[TutorialVideos] upload',
  props<{ payload: TutorialVideoUploadPayload }>(),
);
export const uploadTutorialVideoSuccess = createAction(
  '[TutorialVideos] upload success',
  props<{ video: TutorialVideoSummary }>(),
);
export const uploadTutorialVideoError = createAction(
  '[TutorialVideos] upload error',
  props<{ error: HttpErrorResponse }>(),
);

export const updateTutorialVideo = createAction(
  '[TutorialVideos] update',
  props<{ payload: TutorialVideoUpdatePayload }>(),
);
export const updateTutorialVideoSuccess = createAction(
  '[TutorialVideos] update success',
  props<{ previousId: string; video: TutorialVideoSummary }>(),
);
export const updateTutorialVideoError = createAction(
  '[TutorialVideos] update error',
  props<{ error: HttpErrorResponse }>(),
);

export const deleteTutorialVideo = createAction(
  '[TutorialVideos] delete',
  props<{ tutorialId: string }>(),
);
export const deleteTutorialVideoSuccess = createAction(
  '[TutorialVideos] delete success',
  props<{ tutorialId: string }>(),
);
export const deleteTutorialVideoError = createAction(
  '[TutorialVideos] delete error',
  props<{ error: HttpErrorResponse }>(),
);
